import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ForgotPasswordRequest } from "../@backend";
import useApi from "../hooks/useApi";
import { FooterCmp } from "../ui/layout/Footer";
import { Menu } from "../ui/layout/Menu";
import { PageHeader } from "../ui/ds/PageHeader";
import { Input } from "../ui/ds/Input";
import { Btn } from "../ui/ds/Btn";

export const ForgotPassword = () => {
    const { backend } = useApi(false);
    const [email, setEmail] = useState("");
    const [formErrors, setFormErrors] = useState([] as string[]);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setFormErrors([]);
        setIsSuccess(false);

        if (!email.trim()) {
            setFormErrors(["Vyplňte email."]);
            return;
        }

        setIsSubmitting(true);
        try {
            await backend.user.userControllerForgotPassword({ email: email.trim() } as ForgotPasswordRequest);
            setIsSuccess(true);
        } catch (e: any) {
            setFormErrors([e?.body?.error?.message ?? e?.message ?? "Nepodařilo se odeslat email pro obnovu hesla."]);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Menu />
            <PageHeader title="Zapomenuté heslo" subtitle="Pošleme vám odkaz pro obnovu hesla" />

            <div className="max-w-xl mx-auto px-4 md:px-8 py-8">
                <form onSubmit={handleSubmit} className="bg-bg-card rounded-content shadow-card p-6 md:p-8 flex flex-col gap-5">

                    {isSuccess && (
                        <div className="flex flex-col rounded-card border border-semantic-success/30 bg-semantic-success/10 px-4 py-3 text-text-primary" role="status">
                            <strong className="font-bold text-semantic-success font-nunito">Email odeslán.</strong>
                            <span className="tb-body mt-1">Pokud u nás účet s tímto emailem existuje, poslali jsme odkaz pro obnovu hesla.</span>
                        </div>
                    )}

                    {formErrors.length > 0 && (
                        <div className="flex flex-col rounded-card border border-semantic-danger/30 bg-semantic-danger/10 px-4 py-3" role="alert">
                            <strong className="font-bold text-semantic-danger font-nunito">Obnovu hesla se nepodařilo spustit.</strong>
                            <span className="tb-body mt-1">{formErrors.join(", ")}</span>
                        </div>
                    )}

                    {!isSuccess && (
                        <Input
                            label="Email"
                            type="email"
                            name="email"
                            id="forgot-password-email"
                            autoComplete="email"
                            required
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            placeholder="vas@email.cz"
                        />
                    )}

                    <div className="flex flex-row flex-wrap gap-3 pt-1">
                        <Link to="/" className="flex-1">
                            <Btn variant="ghost" fullWidth>Zpět</Btn>
                        </Link>
                        {!isSuccess && (
                            <div className="flex-1">
                                <Btn type="submit" variant="primary" fullWidth disabled={isSubmitting}>
                                    {isSubmitting ? "Odesílám…" : "Odeslat odkaz"}
                                </Btn>
                            </div>
                        )}
                    </div>
                </form>
            </div>

            <FooterCmp />
        </>
    );
};
